













import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import api from 'src/assets/api/gql'
import ForumTopicUpdate from 'src/graphql/forum/ForumTopicUpdate.gql'
import { ForumTopic } from 'src/graphql/types'

@Component
export default class ForumTopicButtonPinned extends Vue {

  @Prop()
  readonly topic!: ForumTopic

  async toggle () {
    const { data: { updateForumTopic } } = await api.mutate({
      query: ForumTopicUpdate,
      variables: {
        id: this.topic.id,
        patch: {
          pinnedAt: this.topic.pinnedAt ? null : new Date()
        }
      }
    })
    const topic = updateForumTopic?.forumTopic
    if (topic) {
      this.$emit('update', topic)
    }
  }
}
